import React from "react";
import { useQuery } from "react-apollo-hooks";
import { EVENT_CONFIG_QUERY } from "../../Queries";
import InitPresenter from "./Presenter/Init";
import Container from "./Container";

export default () => {
  const { data, loading } = useQuery(EVENT_CONFIG_QUERY);

  if (loading) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }

  if (!loading && data.AdminEventConfig) {
    return (
      <>
        <Container config={data}></Container>
      </>
    );
  }

  if (!loading && !data.AdminEventConfig) {
    return (
      <>
        <InitPresenter></InitPresenter>
      </>
    );
  }
};
